<template>
  <div class="category-container">
    <at-input v-model="search" type="search" placeholder="Категория..." prepend>
      <template slot="prepend">
        <i class="icon icon-search"></i>
      </template>
    </at-input>
    <!-- Первый уровень -->
    <div class="category-content" id="catlist">
      <div v-for="option in options(1, null)" :key="option.id" style="margin-left: 6px" :id="`cat_${option.id}`">
        <at-checkbox v-model="option.selected" :label="option.id" @on-change="select(option)">
          <b v-if="option.level <= 2">{{ option.name }}</b>
          <span v-else>{{ option.name }}</span>
        </at-checkbox>
              <!-- Второй уровень -->
              <div v-for="suboption in options(2, option.id)" :key="suboption.id" style="margin-left: 6px" :id="`cat_${suboption.id}`">
                <at-checkbox v-model="suboption.selected" :label="suboption.id" @on-change="select(suboption)">
                  <b>{{ suboption.name }}</b>
                </at-checkbox>
                              <!-- Третий уровень -->
                              <div v-for="subsuboption in options(3, suboption.id)" :key="subsuboption.id" style="margin-left: 6px" :id="`cat_${subsuboption.id}`">
                                <at-checkbox v-model="subsuboption.selected" :label="subsuboption.id" @on-change="select(subsuboption)">
                                  {{ subsuboption.name }}
                                </at-checkbox>
                              </div>
              </div>
      </div>
    </div>
    <div class="category-footer">
      <at-button type="text" style="width: 50%" @click="selectAll(true)">Выбрать все</at-button>
      <at-button type="text" style="width: 50%" @click="selectAll(false)">Снять выбор</at-button>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
      search: ''
  }),
  methods: {
    options(level, parent) {
      if (this.search != '')
        return this.$store.state.categories.filter.filter(cat => cat.name.toLowerCase().includes(this.search.toLowerCase()) && level == 1)
      else
        return this.$store.state.categories.filter.filter(cat => cat.level == level && cat.parent == parent)
    },
    select(cat) {
      cat.childs.forEach(subcat => {
        subcat.selected = cat.selected
          subcat.childs.forEach(subsubcat => {
          subsubcat.selected = cat.selected
          
        })
      })
    },
    selectAll(val) {
      this.$store.state.categories.filter.forEach(cat => {
        cat.selected = val
      })
    }
  }
}
</script>

<style>
.category-container {
    border: 1px solid #dfdfdf; 
    border-radius: 4px;
}
.category-content {
    height: calc(50vh - 158px);
    overflow-y: auto; 
    overflow-x: hidden;
    scroll-behavior: smooth
}
.category-container input, 
.category-container input:focus, 
.category-container input:hover {
  border: 0;
  border-bottom: 1px solid #dfdfdf;
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
}
.category-container .at-btn:focus {
  outline: 0 !important;
}
.category-container .at-input-group__prepend {
  border: 0 !important;
  border-bottom: 1px solid #dfdfdf !important;
  border-bottom-right-radius: 0px !important;
  border-bottom-left-radius: 0px !important;
}
.category-footer {
  border-top: 1px solid #dfdfdf;
}
</style>